import { module } from 'angular';
import templateBuilderRadioDisplay from './builder/display.html';
import templateBuilderRadioValidate from './builder/validate.html';

export default module('app').run(/* @ngInject */ (
	/** @type {import('angular').ITemplateCacheService} */ $templateCache,
) => {
	$templateCache.put('kform/components/radio/display.html', templateBuilderRadioDisplay);
	$templateCache.put('kform/components/radio/validate.html', templateBuilderRadioValidate);
});
